import { Injectable, inject } from '@angular/core';
import { AlertButton, AlertController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly alertController = inject(AlertController);

  private alert!: HTMLIonAlertElement;

  async showAlert(
    message: string,
    header: string | undefined,
    subHeader: string | undefined,
    buttons: (string | AlertButton)[] | undefined,
  ) {
    this.alert = await this.alertController.create({
      header,
      subHeader,
      message,
      buttons,
    });
    this.alert.present();
  }

  async hide() {
    if (this.alert) await this.alert.dismiss();
  }
}
